/* eslint-disable import/prefer-default-export */
import useTranslation from 'next-translate/useTranslation'

export const companyListResultLabel = (count: number): string => {
  const { t } = useTranslation()
  switch (true) {
    case count === 0:
      return ''
    case count === 1:
      return `${count} ${t('companies:results_singular')}`
    case count % 10 > 1 && count % 10 < 5:
      return `${count} ${t('companies:results_plural')}`
    default:
      return `${count} ${t('companies:results_plural2')}`
  }
}
